module.exports = __webpack_public_path__ + "static/media/pointer.dbaa691b.svg";